import { render, staticRenderFns } from "./page002.vue?vue&type=template&id=1272382d&scoped=true&"
import script from "./page002.vue?vue&type=script&lang=js&"
export * from "./page002.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272382d",
  null
  
)

export default component.exports